/**
 * useServiceAccount Hook
 *
 * React Query hook for fetching a single service account.
 */

import { useQuery } from '@tanstack/react-query';
import { serviceAccountService } from '../../../api/service-account.service';
import type { ServiceAccountSanitized } from '../../../types/service-account.types';

export const SERVICE_ACCOUNT_QUERY_KEY = 'serviceAccount';

export function useServiceAccount(tenantId: string, serviceAccountId: string) {
  return useQuery<ServiceAccountSanitized, Error>({
    queryKey: [SERVICE_ACCOUNT_QUERY_KEY, tenantId, serviceAccountId],
    queryFn: () => serviceAccountService.getServiceAccount(tenantId, serviceAccountId),
    enabled: !!tenantId && !!serviceAccountId,
    staleTime: 30000,
  });
}
